import { State } from "../model/state";
import { apiSlice } from "../stores/base/api-slice";

const statesEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getStates: builder.query<State[], void>({
			query: query => ({
				url: "/states",
				method: "GET",
			})
		}),
	})
});

export const { 
	useLazyGetStatesQuery
} = statesEndpoints;
